export const ROW_HEIGHT_MOBILE = '64px'
export const ROW_HEIGHT_DESKTOP = '40px'

export const TAP_MOBILE = '48px'
export const TAP_DESKTOP = '32px'

export const NETWORK_ICON_SIZE_DESKTOP = '24px'
export const NETWORK_ICON_SIZE_MOBILE = '32px'
